class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    // 共通ナビ（mce-nav）のバッグもドロワーを開く。カートページ上だけは従来どおり遷移させる
    const onCartPage = document.body.classList.contains('mce-page-cart');
    const selector = onCartPage ? '#cart-icon-bubble' : '#cart-icon-bubble, .mce-bag';
    document.querySelectorAll(selector).forEach((cartLink) => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) drawerInner.classList.remove('is-empty');
    this.productId = parsedState.id;

    const hasSections = parsedState.sections && Object.keys(parsedState.sections).length > 0;

    if (hasSections) {
      this.getSectionsToRender().forEach((section => {
        try {
          const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          if (sectionElement && parsedState.sections[section.id]) {
            sectionElement.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          }
        } catch (e) {
          console.error('Cart drawer section render error:', section.id, e);
        }
      }));

      setTimeout(() => {
        const overlay = this.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', this.close.bind(this));
        this.open();
      });
    } else {
      // Fallback: fetch sections separately when response doesn't include them
      const sectionIds = this.getSectionsToRender().map(s => s.id).join(',');
      fetch(`${routes.cart_url}?sections=${sectionIds}`)
        .then(r => r.json())
        .then(sections => {
          this.getSectionsToRender().forEach(section => {
            try {
              const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
              if (sectionElement && sections[section.id]) {
                sectionElement.innerHTML = this.getSectionInnerHTML(sections[section.id], section.selector);
              }
            } catch (e) {
              console.error('Cart drawer fallback render error:', section.id, e);
            }
          });

          setTimeout(() => {
            const overlay = this.querySelector('#CartDrawer-Overlay');
            if (overlay) overlay.addEventListener('click', this.close.bind(this));
            this.open();
          });
        })
        .catch(() => {
          // Even if fallback fails, still open the drawer
          this.open();
        });
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return parsed ? parsed.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
